/*
  Figma "Segmented control": switches between 2–4 views. Track control/track,
  selected segment accent/tinted with a 1px inside edge and an
  accent/tinted-label label; other labels label/secondary. Radii are concentric:
  track radius/control, segment radius/16 with 4px padding. On page backgrounds
  (Discover) the track is material/thin instead of control/track.
*/
const TRACKS = {
  control: "bg-control-track",
  material: "bg-material-thin",
};

const SELECTED = "bg-accent-tinted text-accent-tinted-label shadow-[inset_0_0_0_1px_var(--color-accent-tinted-label)]";

const SegmentedControl = ({ options, value, onChange, label, track = "control", selectedClass = SELECTED, className = "" }) => (
  <div
    role="tablist"
    aria-label={label}
    className={`flex h-[40px] w-full gap-space-8 rounded-control p-space-4 ${TRACKS[track]} ${className}`}
  >
    {options.map((option) => {
      const selected = option.value === value;
      return (
        <button
          key={option.value}
          type="button"
          role="tab"
          aria-selected={selected}
          onClick={() => !selected && onChange(option.value)}
          className={`relative flex min-w-0 flex-1 items-center justify-center rounded-16 px-[12px] text-subheadline-semibold outline-none focus-visible:shadow-[0_0_0_2px_var(--color-focus-ring)] ${
            selected
              ? selectedClass
              : "text-label-secondary after:pointer-events-none after:absolute after:inset-0 after:rounded-[inherit] after:bg-label-primary after:opacity-0 after:transition-opacity hover:after:opacity-[var(--state-hover)] active:after:opacity-[var(--state-pressed)]"
          }`}
        >
          <span className="truncate">{option.label}</span>
        </button>
      );
    })}
  </div>
);

export default SegmentedControl;
